// Date helpers for routes. Route dates are DATEONLY ("YYYY-MM-DD"); parse as a
// local calendar day (not UTC) to avoid an off-by-one shift.
const parseLocalDate = (d) => {
  if (!d) return null;
  const [y, m, day] = String(d).split('-').map(Number);
  if (!y || !m || !day) return null;
  return new Date(y, m - 1, day);
};

export const formatRouteDate = (d) => {
  const date = parseLocalDate(d);
  if (!date) return 'No date';
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
};

// True if a route's date is today or in the future (undated routes count as
// upcoming — they're still being built). Used to hide past routes from pickers.
export const isRouteUpcoming = (d) => {
  const date = parseLocalDate(d);
  if (!date) return true; // no date set yet
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return date >= today;
};

export const routeDateRelative = (d) => {
  const date = parseLocalDate(d);
  if (!date) return 'No date';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const diff = Math.round((date - today) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  return date.toLocaleDateString('en-US', { weekday: 'long' });
};

// ── Address-level stops ───────────────────────────────────────────────────────

// "83 Peters Dr, Groton, CT 06340" — the four-part join used across route views.
export const formatStopAddress = (stop) =>
  [stop?.street, stop?.city, stop?.state, stop?.zipcode].filter(Boolean).join(', ');

// How a stop is titled in lists and pins. A lead can appear more than once on a
// route now, so the address label is what tells the two apart:
//   "Ludson Aiello — Casa Katy"      (labelled additional address)
//   "Ludson Aiello — 184 Ayer Rd"    (unlabelled additional address)
//   "Ludson Aiello"                  (the lead's primary address)
export const formatStopTitle = (stop) => {
  const name = stop?.name || 'Lead';
  if (stop?.isPrimaryAddress) return name;
  const qualifier = stop?.addressLabel || stop?.street;
  return qualifier ? `${name} — ${qualifier}` : name;
};

// Short qualifier on its own, for tight spaces (map pins, chips).
export const stopQualifier = (stop) =>
  stop?.isPrimaryAddress ? 'Primary' : (stop?.addressLabel || stop?.street || 'Address');

export const formatQty = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n.toLocaleString('en-US', { maximumFractionDigits: 2 }) : '—';
};
